import { Button, useStyles, useTheme } from '@archipro-design/aria';
import { Tag } from '@archipro-design/icons';
import React, { useEffect } from 'react';
import { useProductTagging } from '../../context';
import useModalPosition from '../../hooks/use-modal-position';
import type { TagDataUseToCreateTag, TagPosition } from '../../type';
import { convertTagPosition } from '../../util/convert-tag-position';
import ProductTaggingAddSupplierModal from '../product-tagging-add-supplier-modal/ProductTaggingAddSupplierModal';
import ProductTaggingSearchModal from '../product-tagging-search/ProductTaggingSearchModal';
import * as S from './ProductTaggingNewTag.style';

interface ProductTaggingNewTagProps {
    tagPosition: TagPosition;
    show: boolean;
    boxRef: Element;
    onCreateMarker: (data: TagDataUseToCreateTag) => void;
}

const ProductTaggingNewTag = ({
    tagPosition,
    boxRef,
    onCreateMarker,
}: ProductTaggingNewTagProps) => {
    const { css } = useStyles();
    const theme = useTheme();
    const {
        state: { isAddingSupplier },
    } = useProductTagging();

    const {
        setReferenceElement,
        setPopperElement,
        styles,
        attributes,
        update,
        state,
    } = useModalPosition(boxRef);

    // Each time the tagPosition or isAddingSupplier changes, update the position of the popper
    useEffect(() => {
        if (update) update();
    }, [update, tagPosition, isAddingSupplier]);

    const { pctXAfterOffset, pctYAfterOffset } = convertTagPosition(
        tagPosition.pctX,
        tagPosition.pctY,
        tagPosition.rectWidth,
        tagPosition.rectHeight
    );

    return (
        <>
            <div
                ref={setPopperElement}
                style={styles.popper}
                {...attributes.popper}
                className={css(S.SearchModalContainer)}
            >
                {isAddingSupplier ? (
                    <ProductTaggingAddSupplierModal
                        onSubmit={(value) => {
                            onCreateMarker({
                                titleForUnknownProfessional: value,
                            });
                        }}
                    />
                ) : (
                    <ProductTaggingSearchModal
                        onCreateMarker={onCreateMarker}
                        popperState={state}
                    />
                )}
            </div>
            <Button
                size={20}
                variables={{
                    iconPadding: 0,
                    buttonPadding: 12,
                    buttonRadius: '50%',
                }}
                transparent={true}
                icon={
                    <Tag
                        color={theme.siteVariables.naturalColors.white['000']}
                    />
                }
                className={css(S.CurrentTag)}
                ref={setReferenceElement}
                style={{
                    top: `${pctYAfterOffset}%`,
                    left: `${pctXAfterOffset}%`,
                }}
            />
        </>
    );
};

export default ProductTaggingNewTag;
